module.exports = __webpack_public_path__ + "img/deliveryMap3.a79acddb.jpeg";